"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.requestOrganizationTransfersDetails = void 0;
const apollo_1 = require("@app/util/apollo");
const error_handler_1 = require("@app/util/error-handler");
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const query_1 = __importDefault(require("../query"));
const ORGANIZATION_TRANSFER_DETAILS_QUERY = (0, graphql_tag_1.default) `query OrganizationTransferDetails(
   $organizationId: ID!,
   $filter: OrganizationFilter!
   $period: PeriodInput!,
   ) {
  organization(id: $organizationId) {
    transfersDetails(period: $period, filter: $filter) {
      ${query_1.default.TRANSFER_DETAILS_PARAMS}
    }
  }
}`;
const requestOrganizationTransfersDetails = async (variables) => {
    const { data, errors } = await (0, apollo_1.query)(ORGANIZATION_TRANSFER_DETAILS_QUERY, {
        variables,
    });
    (0, error_handler_1.processErrors)(errors);
    return data?.organization.transfersDetails;
};
exports.requestOrganizationTransfersDetails = requestOrganizationTransfersDetails;
/**
 * @deprecated use `requestOrganizationTransfersDetails`
 * `requestOrganizationTransfersDetails` removes legacy token from function signature
 *
 * -> do not import from `@app/request`
 *
 * FIX: impor from `@app/request/organization/transfers-details`
 */
const requestOrganizationTransfersDetailsMap = async (variables, _) => await (0, exports.requestOrganizationTransfersDetails)(variables);
exports.default = requestOrganizationTransfersDetailsMap;
